import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import chartsLanguages from 'statotest-charts/dist/locales/export';

import CanvasJSReact from "./views/charts/canvasjs/canvasjs.react";
const CanvasJS = CanvasJSReact.CanvasJS;

import translationCS from './locales/cs/translation.json';
import translationDE from './locales/de/translation.json';
import translationEN from './locales/en/translation.json';


const resources = {
    cs: {
        translation: { ...translationCS, ...chartsLanguages.chartLangCS },
    },
    de: {
        translation: { ...translationDE, ...chartsLanguages.chartLangDE },
    },
    en: {
        translation: { ...translationEN, ...chartsLanguages.chartLangEN },
    },
}


const domainLanguageDetector = {
    name: 'domainLanguageDetector',
    lookup() {
        const hostname = window.location.hostname;
        if (hostname.endsWith('.cz')) {
            return 'cs'; // Czech
        } else if (hostname.endsWith('.de')) {
            return 'de'; // German
        } else if (hostname.endsWith('.net') || hostname.endsWith('.com')) {
            return 'en'; // English
        }
        return 'en'; // Default language
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: ['de', 'en', 'cs'],
        fallbackLng: 'en', // if selected lng is not present
        interpolation: {
            escapeValue: false,
        },
        resources: resources,
        detection: {
            htmlTag: document.documentElement,
            // order and from where user language should be detected
            order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'domainLanguageDetector', 'htmlTag', 'path', 'subdomain'],
            cookieOptions: { path: '/', sameSite: 'strict' },
            lookupCookie: 'i18next',
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage', 'cookie'],
            convertDetectedLanguage: 'Iso15897',
            // convertDetectedLanguage: (lng) => lng.replace('-', '_')
        },
    });
i18n.services.languageDetector.addDetector(domainLanguageDetector);
export default i18n;

CanvasJS.addCultureInfo("cs", {
    savePNGText: "uložit jako PNG",
    saveJPGText: "uložit jako JPG",

    decimalSeparator: ",", // Observe ToolTip Number Format
    digitGroupSeparator: " ", // Observe axisY labels

    printText: " tisk",
    menuText: "Více možností",

    days: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota",],
    shortDays: ["ne", "po", "út", "st", "čt", "pá", "so"],
    months: ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec",],
    shortMonths: ["led", "úno", "bře", "dub", "kvě", "čv", "čvnc", "srp", "zář", "říj", "lis", "pro",],
});